"use strict";
var Coveo = require("coveo-search-ui");
var DefaultSortHandler_1 = require("../Sorts/DefaultSortHandler");
var SitecoreAnalyticsHandler_1 = require("../Analytics/SitecoreAnalyticsHandler");
var ExpressionHelperUtilities_1 = require("../Rules/ExpressionHelperUtilities");
var CoveoForSitecoreRecommendations = (function () {
    function CoveoForSitecoreRecommendations() {
    }
    CoveoForSitecoreRecommendations.prototype.initRelatedQuery = function (element, searchInterfaceElement, userContext, options) {
        var expressionHelperUtilities = new ExpressionHelperUtilities_1.default();
        var defaultSortHandler = new DefaultSortHandler_1.default(options);
        var domElement = Coveo.$$(element);
        domElement.on(Coveo.QueryEvents.buildingQuery, function (event, args) {
            defaultSortHandler.addSortCriteriaToQuery(args.queryBuilder);
            if (options.filterResultsOnCurrentCulture) {
                var languageFilterExpression = expressionHelperUtilities.getFilterExpression(options.clientLanguageFieldName, options.clientLanguageName);
                args.queryBuilder.constantExpression.add(languageFilterExpression);
            }
        });
        if (options && options.sendToSitecoreAnalytics) {
            var sitecoreAnalyticsHandler = new SitecoreAnalyticsHandler_1.default(options);
            sitecoreAnalyticsHandler.registerSitecoreAnalytics(domElement);
        }
        Coveo.initRecommendation(element, searchInterfaceElement, userContext, options);
    };
    CoveoForSitecoreRecommendations.prototype.initRecommendations = function (element, userContext) {
        Coveo.initRecommendation(element, null, userContext);
    };
    return CoveoForSitecoreRecommendations;
}());
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = CoveoForSitecoreRecommendations;



//////////////////
// WEBPACK FOOTER
// ./Base/Recommendations/CoveoForSitecoreRecommendationsBase.js
// module id = 21
// module chunks = 0